import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Loader from "../Component/Loader/Loader";
import PaymentReturn from "../Pages/Payment/PaymentReturn";
import BookingSummary from "../Pages/BookingSummary/BookingSummary";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const timer = 2200;

const lazyWithDelay = (importFunc, delayMs) =>
  lazy(() => delay(delayMs).then(() => importFunc()));

const HomeLandingList = lazyWithDelay(
  () => import("../HomeList/HomeLandingList"),
  timer
);
const RoomSuit = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomSuit"),
  timer
);
const Gallery = lazyWithDelay(() => import("../Pages/Gallery/Gallery"), timer);
const CafeeKothi = lazyWithDelay(
  () => import("../Pages/CafeeKothi/CafeeKothi"),
  timer
);
const Press = lazyWithDelay(() => import("../Pages/Press/Press"), timer);
const HotelPolicies = lazyWithDelay(
  () => import("../Pages/HotelPolicies/HotelPolicies"),
  timer
);
const Contact = lazyWithDelay(() => import("../Pages/Contact/Contact"), timer);
const ArtKothiPage = lazy(() => import("../Pages/ArtKothiPage/ArtKothiPage"));
const RoomAminities = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomAminities"),
  timer
);
const RoomDetailsKothari = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsKothari"),
  timer
);
const RoomDetailsShaal = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsShaal"),
  timer
);
const RoomDetailsIghdara = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsIghdara"),
  timer
);
const RoomDetailsMedhee = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsMedhee"),
  timer
);
const RoomDetailsOro = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsOro"),
  timer
);
const RoomDetailsJharokha = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsJharokha"),
  timer
);
const RoomDetailsRaavatee = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsRaavatee"),
  timer
);
const RoomDetailsDagala = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsDagala"),
  timer
);
const RoomVilla = lazyWithDelay(
  () => import("../Pages/Rooms&Suit/RoomDetailsVilla"),
  timer
);
const Leisure = lazyWithDelay(() => import("../Pages/Leisure/Leisure"), timer);

// ✅ BookingPage import
const BookPage = lazy(() => import("../Component/Boook/Book"));

const PrivacyPolicy = lazyWithDelay(
  () => import("../Pages/PrivacyPolicy/PrivacyPolicy"),
  timer
);
const TermsConditions = lazyWithDelay(
  () => import("../Pages/TermsConditions/TermsConditions"),
  timer
);
const RefundPolicy = lazyWithDelay(
  () => import("../Pages/RefundPolicy/RefundPolicy"),
  timer
);

// Error Pages
const NotFound404 = lazy(() => import("../Pages/ErrorPages/NotFound404"));
const BadRequest400 = lazy(() => import("../Pages/ErrorPages/BadRequest400"));
const InternalServerError500 = lazy(() =>
  import("../Pages/ErrorPages/InternalServerError500")
);
const Unauthorized401 = lazy(() =>
  import("../Pages/ErrorPages/Unauthorized401")
);
const Forbidden403 = lazy(() => import("../Pages/ErrorPages/Forbidden403"));

function RoutingPage() {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<ArtKothiPage />} />
          <Route path="/RoomSuit" element={<RoomSuit />} />
          <Route path="/Dining" element={<Gallery />} />
          <Route path="/cafekothi" element={<CafeeKothi />} />
          <Route path="/Exclusivity&Events" element={<Press />} />
          <Route path="/hotelpolicies" element={<HotelPolicies />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/homepage" element={<HomeLandingList />} />
          <Route path="/roomanimities" element={<RoomAminities />} />
          <Route path="/Leisure" element={<Leisure />} />
          <Route path="/kothari" element={<RoomDetailsKothari />} />
          <Route path="/shaal" element={<RoomDetailsShaal />} />
          <Route path="/ighdara" element={<RoomDetailsIghdara />} />
          <Route path="/medhee" element={<RoomDetailsMedhee />} />
          <Route path="/oro" element={<RoomDetailsOro />} />
          <Route path="/jharokha" element={<RoomDetailsJharokha />} />
          <Route path="/raavatee" element={<RoomDetailsRaavatee />} />
          <Route path="/dagala" element={<RoomDetailsDagala />} />
          <Route path="/entire-villa" element={<RoomVilla />} />
          {/* ✅ BookingPage routes */}
          <Route path="/booking" element={<BookPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/check-availability" element={<BookPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/payment-return" element={<PaymentReturn />} />
          <Route path="/booking/:bookingId" element={<BookingSummary />} />
          {/* Error Pages */}
          <Route path="/404" element={<NotFound404 />} />
          <Route path="/400" element={<BadRequest400 />} />
          <Route path="/500" element={<InternalServerError500 />} />
          <Route path="/401" element={<Unauthorized401 />} />
          <Route path="/403" element={<Forbidden403 />} />
          {/* Catch all route - 404 for any undefined routes */}
          <Route path="*" element={<NotFound404 />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default RoutingPage;
